var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = function(msg) {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	829: function() { return loadSingletonVersionCheckFallback("default", "react", [1,18,3,1], function() { return __webpack_require__.e(8381).then(function() { return function() { return __webpack_require__(8381); }; }); }); },
	272: function() { return loadSingletonVersionCheckFallback("default", "react-dom", [1,18,3,1], function() { return __webpack_require__.e(1412).then(function() { return function() { return __webpack_require__(1412); }; }); }); },
	6347: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/legacy-ui", [1,1,1,9], function() { return Promise.all([__webpack_require__.e(3530), __webpack_require__.e(9785), __webpack_require__.e(272)]).then(function() { return function() { return __webpack_require__(9785); }; }); }); },
	8825: function() { return loadStrictVersionCheckFallback("default", "i18next", [1,23,11,3], function() { return __webpack_require__.e(7207).then(function() { return function() { return __webpack_require__(7207); }; }); }); },
	5795: function() { return loadStrictVersionCheckFallback("default", "react-i18next", [1,14,1,1], function() { return __webpack_require__.e(9029).then(function() { return function() { return __webpack_require__(9029); }; }); }); },
	8916: function() { return loadStrictVersionCheckFallback("default", "react-router-dom", [1,6,30,2], function() { return Promise.all([__webpack_require__.e(6399), __webpack_require__.e(272)]).then(function() { return function() { return __webpack_require__(6399); }; }); }); },
	1569: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/redkit", [1,2,1,0], function() { return Promise.all([__webpack_require__.e(1888), __webpack_require__.e(4776), __webpack_require__.e(272), __webpack_require__.e(7567)]).then(function() { return function() { return __webpack_require__(4776); }; }); }); },
	2335: function() { return loadStrictVersionCheckFallback("default", "classnames", [1,2,5,1], function() { return __webpack_require__.e(5809).then(function() { return function() { return __webpack_require__(5809); }; }); }); },
	8560: function() { return loadStrictVersionCheckFallback("default", "@apollo/client", [1,3,10,3], function() { return Promise.all([__webpack_require__.e(2902), __webpack_require__.e(3532)]).then(function() { return function() { return __webpack_require__(2902); }; }); }); },
	9058: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/web-auth", [1,4,1,0], function() { return Promise.all([__webpack_require__.e(4911), __webpack_require__.e(3532)]).then(function() { return function() { return __webpack_require__(4911); }; }); }); },
	1537: function() { return loadStrictVersionCheckFallback("default", "date-fns", [1,3,6,0], function() { return __webpack_require__.e(3024).then(function() { return function() { return __webpack_require__(3024); }; }); }); },
	6193: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/frontend-kit", [1,3,0,1], function() { return __webpack_require__.e(5559).then(function() { return function() { return __webpack_require__(5559); }; }); }); },
	5221: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/hs-math", [1,1,13,2], function() { return Promise.all([__webpack_require__.e(2232), __webpack_require__.e(953)]).then(function() { return function() { return __webpack_require__(2232); }; }); }); },
	3258: function() { return loadStrictVersionCheckFallback("default", "formik", [1,2,4,6], function() { return __webpack_require__.e(5783).then(function() { return function() { return __webpack_require__(5783); }; }); }); },
	8310: function() { return loadStrictVersionCheckFallback("default", "yup", [2,0,32,11], function() { return __webpack_require__.e(3109).then(function() { return function() { return __webpack_require__(3109); }; }); }); },
	1028: function() { return loadStrictVersionCheckFallback("default", "moveto", [1,1,8,2], function() { return __webpack_require__.e(7966).then(function() { return function() { return __webpack_require__(7966); }; }); }); },
	4251: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/forms", [1,5,2,0], function() { return __webpack_require__.e(8454).then(function() { return function() { return __webpack_require__(8454); }; }); }); },
	6496: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/siv-reference-number", [1,1,2,0], function() { return __webpack_require__.e(9807).then(function() { return function() { return __webpack_require__(9807); }; }); }); },
	6964: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/rich-text-editor", [1,1,1,6], function() { return __webpack_require__.e(9352).then(function() { return function() { return __webpack_require__(9352); }; }); }); },
	7809: function() { return loadStrictVersionCheckFallback("default", "lodash.topath", [1,4,5,2], function() { return __webpack_require__.e(346).then(function() { return function() { return __webpack_require__(346); }; }); }); },
	7907: function() { return loadStrictVersionCheckFallback("default", "react-beautiful-dnd", [1,13,1,1], function() { return __webpack_require__.e(4546).then(function() { return function() { return __webpack_require__(4546); }; }); }); },
	3532: function() { return loadStrictVersionCheckFallback("default", "graphql", [1,16,8,1], function() { return Promise.all([__webpack_require__.e(1635), __webpack_require__.e(6736)]).then(function() { return function() { return __webpack_require__(6736); }; }); }); },
	7567: function() { return loadStrictVersionCheckFallback("default", "@hs-baumappe/graphql-errors", [1,1,1,0], function() { return Promise.all([__webpack_require__.e(1635), __webpack_require__.e(8998)]).then(function() { return function() { return __webpack_require__(8998); }; }); }); },
	5220: function() { return loadStrictVersionCheckFallback("default", "chart.js", [1,4,4,7], function() { return Promise.all([__webpack_require__.e(9107), __webpack_require__.e(9693)]).then(function() { return function() { return __webpack_require__(9693); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"272": [
		272
	],
	"829": [
		829
	],
	"1667": [
		3258,
		8310
	],
	"2613": [
		1537,
		6193
	],
	"3532": [
		3532
	],
	"4100": [
		5221
	],
	"4303": [
		1028,
		4251,
		6496,
		6964,
		7809,
		7907
	],
	"5220": [
		5220
	],
	"6347": [
		6347
	],
	"7567": [
		7567
	],
	"7597": [
		5795,
		8916
	],
	"7691": [
		1569,
		2335,
		8560,
		9058
	],
	"8825": [
		8825
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}